// 极简 fetch 封装：自动带 cookie，自动 JSON，统一错误处理
async function request(method, url, options = {}) {
  const opts = {
    method,
    credentials: 'include',
    headers: { ...(options.headers || {}) },
    ...options
  };
  if (opts.json !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(opts.json);
    delete opts.json;
  }
  const res = await fetch(url, opts);
  const ct = res.headers.get('content-type') || '';
  let body = null;
  if (ct.includes('application/json')) {
    try { body = await res.json(); } catch (_) { body = null; }
  } else {
    try { body = await res.text(); } catch (_) { body = null; }
  }
  if (!res.ok) {
    const msg = (body && (body.message || body.detail)) || ('HTTP ' + res.status);
    const err = new Error(msg);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export const api = {
  get: (url, options) => request('GET', url, options),
  post: (url, options) => request('POST', url, options),
  put: (url, options) => request('PUT', url, options),
  del: (url, options) => request('DELETE', url, options)
};
